import { UserRole } from "@/api/api.dto";
import { useUser } from "@/stores/user/user";

export const roleGuard = (roles: UserRole[]) => {
  return async (to, from) => {
    const userStore = useUser();

    const falsyRoute = userStore.userIsLoggined
      ? { name: userStore.isUserSupport ? "supportAdmin" : "productsList" }
      : { name: "login" };

    if (!userStore.user) {
      return falsyRoute;
    }

    if (
      !userStore.user.role &&
      userStore.user.role !== 0 &&
      userStore.user.role !== UserRole.Support
    ) {
      return falsyRoute;
    }

    return roles.includes(userStore.user.role) || falsyRoute;
  };
};
